import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class Register {

    constructor(private http: Http) {}

    save(account: any): Observable<any> {
        return this.http.post('api/register', account);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.service.ts